import {useQuery} from '@tanstack/react-query'
import axios from 'axios'

export const useStoreListData = () => {
  // const dataUrl = 'http://localhost:3002/store-list'
  const dataUrl = 'https://private-a0583-b2brewardsadmin.apiary-mock.com/api/v1/stores?page=1&pageSize=10'
  const columnUrl = 'http://localhost:3001/columns'

  // Query hook to fetch store list data from API
  // Uses dataUrl as dependency to refetch when URL changes
  // Returns array of store items or empty array if no data
  const rowQuery = useQuery({
    queryKey: ['storeListRowData', dataUrl],
    queryFn: async () => {
      const {data} = await axios.get(dataUrl)
      const items = data?.items || [] // Safely access items with fallback
      return items
    },
  })

  const colQuery = useQuery({
    queryKey: ['storeListColConfig', columnUrl],
    queryFn: async () => {
      const {data} = await axios.get(columnUrl)
      return data
    },
  })

  return {
    rowData: rowQuery.data,
    colConfig: colQuery.data,
    // isLoading: rowQuery.isLoading || colQuery.isLoading,
    // isError: rowQuery.isError || colQuery.isError,
    isLoading: rowQuery.isLoading,
    isError: rowQuery.isError,
  }
}
